import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Situation } from 'src/app/shared/models/situation';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class SituationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllSituation(): Observable<Situation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.situationUrl}/all`,
			'getAllSituation'
		);
	}

	importSituation(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'situation.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.situationUrl}/import`,
			`importSituation`,
			formData
		);
	}

	getSituationById(id: number): Observable<Situation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.situationUrl}/get/${id}`,
			'getSituationById'
		);
	}

	updateSituation(situation: Situation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.situationUrl}/update/${situation.id}`,
			'updateSituation',
			situation
		);
	}

	addSituation(situation: Situation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.situationUrl}/add`,
			'addSituation',
			situation
		);
	}

	deleteSituation(situationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.situationUrl}/delete/${situationId}`,
			`deleteSituation`
		);
	}
}
